// GENERATED by scripts/build-icons.mjs from icons/check.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Check = createIcon('check', [
  ['path', { d: "M20 6 9 17l-5-5" }],
])
